export const IMAGE_QUALITY = {
    VERY_HIGH: 100,
    HIGH: 95,
    MEDIUM_HIGH: 90,
    MEDIUM: 75,
    MEDIUM_LOW: 50,
    LOW: 25,
    VERY_LOW: 10,
};
